module.exports = __webpack_public_path__ + "static/media/ic_live_red.82d32bee.svg";